"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormState = void 0;
const react_1 = require("react");
function useFormState() {
    const [formState, setFormState] = (0, react_1.useState)({
        isDirty: false,
        isValid: false,
    });
    return [formState, setFormState];
}
exports.useFormState = useFormState;
